<template>
  <Form
    label-position="right"
    :model="dataDetails"
    :label-width="100"
    :rules="ruleFrom"
    ref="dataDetails"
    class="my-content"
  >
    <FormItem :label="$t('countryName')" prop="country">
      <Select
        v-model="dataDetails.country"
        filterable
        @on-change="countryChange"
        :placeholder="$t('select') + $t('countryName')"
      >
        <Option v-for="item in countryList" :value="item.id" :key="item.id">{{
          item.title
        }}</Option>
      </Select>
    </FormItem>
    <FormItem :label="$t('city_name')" prop="city">
      <Select
        v-model="dataDetails.city"
        filterable
        :placeholder="$t('select') + $t('city_name')"
        :disabled="disabled"
      >
        <Option v-for="item in cityList" :value="item.title" :key="item.id">{{
          item.title
        }}</Option>
      </Select>
    </FormItem>
    <FormItem :label="$t('tracker_code')" prop="traceCode">
      <Select
        v-model="dataDetails.traceCode"
        filterable
        :placeholder="$t('select') + $t('tracker_code')"
        @on-change="traceCodeChange"
      >
        <Option
          v-for="item in statusList"
          :value="item.tracker_code"
          :key="item.tracker_code"
          >{{ item.tracker_code }}-{{ item.tracker_description }}</Option
        >
      </Select>
    </FormItem>
    <FormItem
      v-if="
        dataDetails.traceCode && dataDetails.traceCode.split('-')[0] == 'DS'
      "
      :label="$t('Remarks')"
    >
      <Select
        v-model="dataDetails.remarks"
        filterable
        :placeholder="$t('select') + $t('Remarks')"
      >
        <Option
          v-for="item in remarksList"
          :value="item.value"
          :key="item.value"
          >{{ item.label }}</Option
        >
      </Select>
    </FormItem>
    <!-- <FormItem :label="$t('Remarks')">
      <Input
        v-model="dataDetails.remarks"
        filterable
        placeholder="描述不一样可填写自定义描述"
      ></Input>
    </FormItem> -->
    <FormItem :label="$t('upTime')" prop="time">
      <DatePicker
        format="yyyy-MM-dd HH:mm:ss"
        type="datetime"
        placeholder="Please select DateTime"
        style="width: 100%"
        v-model="dataDetails.time"
      ></DatePicker>
    </FormItem>
    <FormItem :label="$t('offset')">
      <Input v-model="dataDetails.offset">
        <template #append>
          <Select v-model="dataDetails.offsetType" style="width: 80px">
            <Option value="SEC">秒</Option>
            <Option value="MIN">分钟</Option>
            <Option value="HOR">小时</Option>
            <Option value="DAY">天</Option>
          </Select>
        </template>
      </Input>
    </FormItem>
    <FormItem :label="$t('order_number')" prop="airwayNumber">
      <Input
        v-model.trim="dataDetails.airwayNumber"
        type="textarea"
        :rows="15"
        placeholder="Please Enter CnbNumber"
      ></Input>
    </FormItem>
    <div style="width: 100%; text-align: center">
      <Button
        type="primary"
        class="submit-btn"
        size="large"
        @click="confirm('dataDetails')"
        icon="md-add"
      >
        {{ $t("order_submit") }}
      </Button>
    </div>
  </Form>
</template>

<script>
import { add } from "@/api/order/trace";
import common from "_c/common-body";
import boxMes from "@/utils/message";
import bagTable from "_my/bag-table";
import { getCountry } from "@/api/system/country";
import { getCity } from "@/api/system/city";
import { getStatus } from "@/api/tracker/status";
import format from "@/utils/format";
import { getSelectType } from "@/api/public";
import moment from "moment";

export default {
  name: "updateTrace",
  components: {
    common,
    bagTable,
  },
  data() {
    return {
      current: 1,
      arrPageSize: [15, 30, 50, 100],
      maskClosable: false,
      loading: true,
      width: 600,
      offsetTimeRange: moment().format("YYYY-MM-DD HH:mm:ss"),
      list: [],
      searchFrom: {
        page: 1,
        pageSize: 15,
        keywords: "",
      },
      // Warehouse总数据
      total: 0,
      // 详情模态框显示/隐藏
      isshowModal: false,
      // 数据详情
      dataDetails: {
        time: new Date(),
        offset: 0,
        offsetType: 'SEC'
      },
      // 删除模态显示/隐藏
      Delmodal1: false,
      // 模态框标题
      isshowModalTitle: "",
      ruleFrom: {
        airwayNumber: [
          {
            required: true,
            message: this.$t("select") + this.$t("order_number"),
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            type: "number",
            message: this.$t("select") + this.$t("countryName"),
            trigger: "change",
          },
        ],
        city: [
          {
            required: true,
            type: "string",
            message: this.$t("select") + this.$t("city_name"),
            trigger: "change",
          },
        ],
        traceCode: [
          {
            required: true,
            message: this.$t("select") + this.$t("tracker_code"),
            trigger: "change",
          },
        ],
        time: [
          {
            required: true,
            type: "date",
            message: this.$t("select") + this.$t("upTime"),
            trigger: "change",
          },
        ],
      },
      footerHide: false,
      crudText: "",
      titleModal: "",
      deleteModal: false,
      delId: 0,
      preForm: {},
      unChange: true,
      dateTime: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      countryList: [],
      cityList: [],
      statusList: [],
      tableTitle: [],
      disabled: true,
      remarksList: [],
    };
  },
  watch: {
    dataDetails: {
      handler: function (nowVal) {
        var $this = this;
        for (let i in $this.dataDetails) {
          if (nowVal[i] !== $this.preForm[i]) {
            $this.unChange = false;
            break;
          } else {
            $this.unChange = true;
          }
        }
      },
      deep: true,
    },

  },
  mounted() {
    this.getOtherList();
  },
  methods: {
    traceCodeChange(val) {
      let codes = ['110','111','112','SAA','AAA','CCS']
      if(codes.includes(val)){
        this.$Modal.info({
          width: 350,
          title: this.$tz('请录入当地时间'),
        })
      }
      console.log(val);
    },
    getOtherList() {
      getCountry().then((res) => {
        this.countryList = res.data.payload.rows;
      });
      getStatus().then((res) => {
        this.statusList = res.data.payload.rows;
      });
      getSelectType(["DS_REMARKS"]).then((res) => {
        this.remarksList = res.data.payload["DS_REMARKS"];
        this.dataDetails.remarks = this.remarksList[0].value;
      });
    },
    countryChange(val) {
      getCity({ country_id: val }).then((res) => {
        this.cityList = res.data.payload.rows;
        this.disabled = false;
      });
    },
    confirm(name) {
      console.log(this.dataDetails);

      this.$refs[name].validate((valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.dataDetails));
          data.airwayNumber = data.airwayNumber.split(/\s+/);
          data.time = format.timeFormat(data.time);
          add(data).then((res) => {
            if (res.data.status) {
              this.$Message["success"]({
                background: true,
                content: res.data.msg,
              });
              this.disabled = true;
              this.$refs[name].resetFields();
            } else {
              this.$Message["error"]({
                background: true,
                content: res.data.msg,
                duration: 5,
              });
            }
          });
        } else {
          console.log(this.dataDetails);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.delBtn {
  margin: 0 10px;
}
.ivu-page {
  margin-top: 20px;
}
.footer-modal {
  width: 100%;
  text-align: center;
}
.submit-btn {
  width: 150px;
  margin: 0 auto;
}
.my-content {
  height: 100%;
  background: #fff;
  border-radius: 6px;
  padding: 20px;
}
</style>
